/**
 * Sepet önerileri (snippets/pestegroshoe-cart-upsell.liquid): numara seçilip "Sepete ekle"ye basılınca
 * ürünü sepete ekler ve Horizon'un kendi sepet güncelleme olayını yayınlar. Böylece sepet çekmecesi /
 * sepet sayfası, sepet ikonu ve indirim çubuğu sayfa yenilenmeden güncellenir.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const showError = (card, message) => {
  const el = card.querySelector('[data-pg-upsell-error]');
  if (!el) return;
  el.textContent = message;
  el.hidden = false;
};

document.addEventListener('change', (e) => {
  const select = e.target.closest?.('[data-pg-upsell-card] select');
  if (!select) return;
  const card = select.closest('[data-pg-upsell-card]');
  card.classList.remove('is-error');
  card.querySelector('[data-pg-upsell-error]')?.setAttribute('hidden', '');
});

document.addEventListener('click', async (e) => {
  const button = e.target.closest?.('[data-pg-upsell-add]');
  if (!button || button.disabled) return;

  const card = button.closest('[data-pg-upsell-card]');
  const input = card.querySelector('[data-pg-upsell-variant]');
  const variantId = input?.value;

  if (!variantId) {
    card.classList.add('is-error');
    showError(card, 'Lütfen numaranızı seçin.');
    input?.focus();
    return;
  }

  button.disabled = true;
  button.classList.add('is-loading');

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  card.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Ürün eklenemedi.');

    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
      r.json()
    );

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        sections: data.sections,
        source: 'pg-cart-upsell',
        didError: false,
      },
    });
  } catch (error) {
    button.disabled = false;
    button.classList.remove('is-loading');
    showError(card, error.message || 'Ürün eklenemedi, lütfen tekrar deneyin.');
    deferred.resolve({ cart: null, detail: { didError: true, source: 'pg-cart-upsell' } });
  }
});
